export default __webpack_public_path__ + "static/media/silvermoon4.d610e835.jpg";